module.exports = __webpack_public_path__ + "static/media/acceptable-images.b577e283.PNG";